import contents from './components/contents.vue'
import imglist from './components/imglist.vue'
import successpay from './components/successpay.vue'
import dingdanzl from './components/dingdanzl.vue'
import login from './components/login.vue'
import kongzhi from './components/kongzhi.vue'
import faqipay from './components/faqipay.vue'
import shengming from './components/shengming.vue'

export var routerjs = [
    {
      path:'/',
      component:dingdanzl
    },
    {
      path:'/upimg',
      component:contents  
    },
    {
      path:'/imglist',
      component:imglist  
    },
    {
      path:'/successpay',
      component:successpay  
    },
    {
      path:'/login',
      component:login
    },
    {
      path:'/kongzhi',
      component:kongzhi
    },
    {
      path:'/faqipay',
      component:faqipay
    },
    {
      path:'/shengming',
      component:shengming
    },
    //路由重定向
    {
      path:'*',
      redirect: '/'
    }
]



// WEBPACK FOOTER //
// ./src/routerjs.js